import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';

export default class PaymentSchedule extends BaseModel {
  constructor({id, designation, percentage, amount, transaction, sortOrder}) {
    super(id, undefined, designation);
    this.percentage = percentage;
    this.amount = amount;
    this.transaction = transaction;
    this.sortOrder = sortOrder;
  }

  static get fkName() {
    return 'payment_schedule_id';
  }
  static get apiRoute() {
    return 'payment_schedule';
  }
  static get detailPageRoute() {
    return undefined;
  }
  static get listPageRoute() {
    return undefined;
  }
  get fkName() {
    return PaymentSchedule.fkName;
  }
  get apiRoute() {
    return PaymentSchedule.apiRoute;
  }
  get detailPageRoute() {
    return PaymentSchedule.detailPageRoute;
  }
  get listPageRoute() {
    return PaymentSchedule.listPageRoute;
  }

  static get joinAttrsKey() {
    return ['designation'];
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(
      ['designation', 'percentage', 'amount', 'transaction'],
      ['sortOrder'],
    );
  }

  static get allAttributes() {
    return [
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '1.5fr'}),
      new AT.DecimalAttribute({
        name: 'percentage',
        decimalPrecision: 2,
        tableProperties: {
          header: 'hit-app.tax-code.percentage',
          maxWidth: '0.8fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'amount',
        decimalPrecision: 2,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.common.amount',
          maxWidth: '1fr',
        },
      }),
      new AT.FkTransactionAttribute({
        name: 'transaction',
        joinPath: [
          'transaction!fk_payment_schedule_transaction_id_transaction',
        ],
        onlyFetchDesignation: true,
        tableProperties: {
          header: 'hit-base.common.transaction',
          maxWidth: '1.2fr',
          readOnly: true,
        },
        readonly: true,
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        creationValue: 'SORT_ORDER_NULL_VALUE',
      }),
    ];
  }
}
